import { render, staticRenderFns } from "./WritingPhonics2Form.vue?vue&type=template&id=d4f98e7c&"
import script from "./WritingPhonics2Form.vue?vue&type=script&lang=js&"
export * from "./WritingPhonics2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports